"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateExpenseData = exports.expenseFormRules = exports.validateMedicalExpenseData = exports.medicalExpenseFormRules = exports.medicalExpenseSchema = exports.validateChildCareExpenseData = exports.childCareExpenseFormRules = exports.childCareExpenseSchema = exports.expenseFieldMapping = exports.expenseSchema = void 0;
// Base expense schema
__exportStar(require("./expense"), exports);
// Expense type schemas
__exportStar(require("./child-care"), exports);
__exportStar(require("./medical"), exports);
// Re-export for convenience
var expense_1 = require("./expense");
Object.defineProperty(exports, "expenseSchema", { enumerable: true, get: function () { return expense_1.expenseSchema; } });
Object.defineProperty(exports, "expenseFieldMapping", { enumerable: true, get: function () { return expense_1.expenseFieldMapping; } });
var child_care_1 = require("./child-care");
Object.defineProperty(exports, "childCareExpenseSchema", { enumerable: true, get: function () { return child_care_1.childCareExpenseSchema; } });
Object.defineProperty(exports, "childCareExpenseFormRules", { enumerable: true, get: function () { return child_care_1.childCareExpenseFormRules; } });
Object.defineProperty(exports, "validateChildCareExpenseData", { enumerable: true, get: function () { return child_care_1.validateChildCareExpenseData; } });
var medical_1 = require("./medical");
Object.defineProperty(exports, "medicalExpenseSchema", { enumerable: true, get: function () { return medical_1.medicalExpenseSchema; } });
Object.defineProperty(exports, "medicalExpenseFormRules", { enumerable: true, get: function () { return medical_1.medicalExpenseFormRules; } });
Object.defineProperty(exports, "validateMedicalExpenseData", { enumerable: true, get: function () { return medical_1.validateMedicalExpenseData; } });
// Also export the original expense functions for backward compatibility
const converters_1 = require("../../converters");
const expense_2 = require("./expense");
exports.expenseFormRules = (0, converters_1.toReactHookForm)(expense_2.expenseSchema, expense_2.expenseFieldMapping);
exports.validateExpenseData = (0, converters_1.createValidator)(expense_2.expenseSchema);
